import React from 'react';
import {
  Divider, List, ListItemButton, ListItemIcon, ListItemText, Tooltip,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import StarIcon from '@mui/icons-material/Star';
import MapIcon from '@mui/icons-material/Map';
import TimelineIcon from '@mui/icons-material/Timeline';
import PauseCircleFilledIcon from '@mui/icons-material/PauseCircleFilled';
import PlayCircleFilledIcon from '@mui/icons-material/PlayCircleFilled';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import BarChartIcon from '@mui/icons-material/BarChart';
import RouteIcon from '@mui/icons-material/Route';
import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from '../../common/components/LocalizationProvider';
import { useAdministrator } from '../../common/util/permissions';

const MenuItem = ({
  title, link, icon, selected,
}) => (
  <ListItemButton key={link} component={Link} to={link} selected={selected}>
    <ListItemIcon>{icon}</ListItemIcon>
    <ListItemText primary={title} />
  </ListItemButton>
);

const ReportsMenu = () => {
  const t = useTranslation();
  const location = useLocation();

  const admin = useAdministrator();

  return (
    <>
      <List>
        <MenuItem
          link="/"
          icon={<Tooltip title="MAPA" placement="right"><MapIcon sx={{ color: grey[500] }} /></Tooltip>}
          selected={location.pathname === '/'}
        />
        <MenuItem
          title={t('reportCombined')}
          link="/reports/combined"
          icon={<Tooltip title="COMBINADO" placement="right"><StarIcon sx={{ color: grey[500] }} /></Tooltip>}
          selected={location.pathname === '/reports/combined'}
        />
        <MenuItem
          title={t('reportRoute')}
          link="/reports/route"
          icon={<Tooltip title="ROTAS" placement="right"><TimelineIcon sx={{ color: grey[500] }} /></Tooltip>}
          selected={location.pathname === '/reports/route'}
        />
        <MenuItem
          title={t('reportEvents')}
          link="/reports/event"
          icon={<Tooltip title="EVENTOS" placement="right"><NotificationsActiveIcon sx={{ color: grey[500] }} /></Tooltip>}
          selected={location.pathname === '/reports/event'}
        />
        <MenuItem
          title={t('reportTrips')}
          link="/reports/trip"
          icon={<Tooltip title="VIAGENS" placement="right"><PlayCircleFilledIcon sx={{ color: grey[500] }} /></Tooltip>}
          selected={location.pathname === '/reports/trip'}
        />
        <MenuItem
          title={t('reportStops')}
          link="/reports/stop"
          icon={<Tooltip title="PARADAS" placement="right"><PauseCircleFilledIcon sx={{ color: grey[500] }} /></Tooltip>}
          selected={location.pathname === '/reports/stop'}
        />
        <MenuItem
          title={t('reportSummary')}
          link="/reports/summary"
          icon={<Tooltip title="RESUMO" placement="right"><FormatListBulletedIcon sx={{ color: grey[500] }} /></Tooltip>}
          selected={location.pathname === '/reports/summary'}
        />
        <MenuItem
          title={t('reportChart')}
          link="/reports/chart"
          icon={<Tooltip title="GRAFICOS" placement="right"><TrendingUpIcon sx={{ color: grey[500] }} /></Tooltip>}
          selected={location.pathname === '/reports/chart'}
        />
        <MenuItem
          title={t('reportReplay')}
          link="/replay"
          icon={<Tooltip title="REPRODUZIR" placement="right"><RouteIcon sx={{ color: grey[500] }} /></Tooltip>}
        />
      </List>
      <Divider />
      <List>
        <MenuItem
          title={t('reportScheduled')}
          link="/reports/scheduled"
          icon={<Tooltip title="AGENDADOS" placement="right"><EventRepeatIcon sx={{ color: grey[500] }} /></Tooltip>}
        />
        {admin && (
          <MenuItem
            title={t('statisticsTitle')}
            link="/reports/statistics"
            icon={<Tooltip title="ESTATISTICAS" placement="right"><BarChartIcon sx={{ color: grey[500] }} /></Tooltip>}
            selected={location.pathname === '/reports/statistics'}
          />
        )}
      </List>
    </>
  );
};

export default ReportsMenu;
